import { useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Divider, Grid, Typography } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { CalendarView } from "../components/CalendarView";
import { OperationList } from "../components/OperationList";
import { OperationHistory } from "../components/OperationHistory";

export const RecurringTasks = () => {

    const { projectId } = useParams<{ projectId: string }>();

    const [selectedOperation, setSelectedOperation] = useState<any | null>(null);

    return (
        <Grid container height={'100%'}>
            <Grid size={3} height={'100%'} borderRight={1} borderColor={'divider'}>
                <OperationList projectId={projectId} selectedOperation={selectedOperation} setSelectedOperation={setSelectedOperation} />
            </Grid>
            <Grid size={9} height={'100%'}>
                {
                    selectedOperation ? (
                        <Box py={2}>
                            <Box display={'flex'} alignItems={'center'} gap={2} px={2}>
                                <ArrowBackIcon onClick={() => setSelectedOperation(null)} style={{ cursor: 'pointer' }} />
                                <Typography variant="subtitle1">Detailed view for operation : {selectedOperation.name}</Typography>
                            </Box>
                            <Divider sx={{ my: 2 }} />
                            <OperationHistory projectId={projectId} activityId={selectedOperation.id} />
                        </Box>
                    ) : (
                        <CalendarView projectId={projectId} />
                    )
                }
            </Grid>
        </Grid>
    );

};